import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _attributeSummary = { average: 'DOUBLE' };
var _createRatingRequest = { rating: '_rating' };
var _createRatingResponse = { rating: '_rating' };
var _deleteRatingRequest = {};
var _deleteRatingResponse = {};
var _entityAverage = { average: 'DOUBLE' };
var _getEntitySummaryRequest = {};
var _getEntitySummaryResponse = { attributeSummaries: '_attributeSummary' };
var _getGroupSummaryRequest = {};
var _getGroupSummaryResponse = { attributeSummaries: '_attributeSummary' };
var _getRatingRequest = {};
var _getRatingResponse = { rating: '_rating' };
var _listAttributeAveragesByEntityRequest = {};
var _listAttributeAveragesByEntityResponse = {
    entityAverages: '_entityAverage',
};
var _queryRatingsRequest = {};
var _queryRatingsResponse = { ratings: '_rating' };
var _rating = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _updateRatingRequest = {
    mask: 'google.protobuf.FieldMask',
    rating: '_rating',
};
var _updateRatingResponse = { rating: '_rating' };
function resolveComWixpressCritiqueRatingsRatingsUrl(opts) {
    var domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/ratings/v1/ratings',
                destPath: '/v1/ratings',
            },
        ],
        _: [
            {
                srcPath: '/_api/ratings/v1',
                destPath: '/v1',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates a new rating.
 *
 *
 * The request body must include `group`, `entityId`, and rating `value`.
 */
export function createRating(payload) {
    var _a = serializer(_createRatingRequest, { _rating: _rating }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createRatingResponse, { _rating: _rating }).fromJSON;
    function __createRating(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ratings.v1.rating',
            method: 'POST',
            methodFqn: 'com.wixpress.critique.ratings.Ratings.CreateRating',
            url: resolveComWixpressCritiqueRatingsRatingsUrl({
                protoPath: '/v1/ratings',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createRating.fromReq = fromReq;
    return __createRating;
}
/** Retrieves a rating by ID. */
export function getRating(payload) {
    var _a = serializer(_getRatingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getRatingResponse, { _rating: _rating }).fromJSON;
    function __getRating(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ratings.v1.rating',
            method: 'GET',
            methodFqn: 'com.wixpress.critique.ratings.Ratings.GetRating',
            url: resolveComWixpressCritiqueRatingsRatingsUrl({
                protoPath: '/v1/ratings/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getRating.fromReq = fromReq;
    return __getRating;
}
/**
 * Updates a rating or list of related entities.
 *
 *
 * Each time the rating is updated, `revision` increments by 1. The existing `revision` must be included
 * when updating the rating. This ensures you're working with the latest rating information, and it prevents unintended overwrites.
 */
export function updateRating(payload) {
    var _a = serializer(_updateRatingRequest, { _rating: _rating }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateRatingResponse, { _rating: _rating }).fromJSON;
    function __updateRating(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ratings.v1.rating',
            method: 'PATCH',
            methodFqn: 'com.wixpress.critique.ratings.Ratings.UpdateRating',
            url: resolveComWixpressCritiqueRatingsRatingsUrl({
                protoPath: '/v1/ratings/{rating.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateRating.fromReq = fromReq;
    return __updateRating;
}
/** Deletes a rating by ID. */
export function deleteRating(payload) {
    var _a = serializer(_deleteRatingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteRatingResponse, {}).fromJSON;
    function __deleteRating(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ratings.v1.rating',
            method: 'DELETE',
            methodFqn: 'com.wixpress.critique.ratings.Ratings.DeleteRating',
            url: resolveComWixpressCritiqueRatingsRatingsUrl({
                protoPath: '/v1/ratings/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteRating.fromReq = fromReq;
    return __deleteRating;
}
/** Retrieves a rating summary for a group. */
export function getGroupSummary(payload) {
    var _a = serializer(_getGroupSummaryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getGroupSummaryResponse, {
        _attributeSummary: _attributeSummary,
    }).fromJSON;
    function __getGroupSummary(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ratings.v1.rating',
            method: 'GET',
            methodFqn: 'com.wixpress.critique.ratings.Ratings.GetGroupSummary',
            url: resolveComWixpressCritiqueRatingsRatingsUrl({
                protoPath: '/v1/ratings/groups/{group}/summary',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getGroupSummary.fromReq = fromReq;
    return __getGroupSummary;
}
/** Retrieves a rating summary for the requested entity. */
export function getEntitySummary(payload) {
    var _a = serializer(_getEntitySummaryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getEntitySummaryResponse, {
        _attributeSummary: _attributeSummary,
    }).fromJSON;
    function __getEntitySummary(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ratings.v1.rating',
            method: 'GET',
            methodFqn: 'com.wixpress.critique.ratings.Ratings.GetEntitySummary',
            url: resolveComWixpressCritiqueRatingsRatingsUrl({
                protoPath: '/v1/ratings/groups/{group}/entities/{entityId}/summary',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getEntitySummary.fromReq = fromReq;
    return __getEntitySummary;
}
/** Retrieves average attribute ratings for entities in a group. */
export function listAttributeAveragesByEntity(payload) {
    var _a = serializer(_listAttributeAveragesByEntityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listAttributeAveragesByEntityResponse, { _entityAverage: _entityAverage }).fromJSON;
    function __listAttributeAveragesByEntity(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ratings.v1.rating',
            method: 'POST',
            methodFqn: 'com.wixpress.critique.ratings.Ratings.ListAttributeAveragesByEntity',
            url: resolveComWixpressCritiqueRatingsRatingsUrl({
                protoPath: '/v1/ratings/groups/{group}/attributes/average',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listAttributeAveragesByEntity.fromReq = fromReq;
    return __listAttributeAveragesByEntity;
}
/**
 * Retrieves a list of ratings, given the provided paging, filtering, and sorting.
 * 100 ratings can be returned per request.
 *
 * Query Ratings runs with these defaults, which you can override:
 *
 * - `createdDate` is sorted in `ASC` order
 * - `paging.limit` is `100`
 *
 * For field support for filters and sorting, see
 * [Ratings: Supported Filters and Sorting](https://dev.wix.com/api/rest/ratings/sort-and-filter).
 * To learn about working with _Query_ endpoints, see
 * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
 */
export function queryRatings(payload) {
    var _a = serializer(_queryRatingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryRatingsResponse, { _rating: _rating }).fromJSON;
    function __queryRatings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ratings.v1.rating',
            method: 'POST',
            methodFqn: 'com.wixpress.critique.ratings.Ratings.QueryRatings',
            url: resolveComWixpressCritiqueRatingsRatingsUrl({
                protoPath: '/v1/ratings/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryRatings.fromReq = fromReq;
    return __queryRatings;
}
//# sourceMappingURL=http.impl.js.map